export default "__VITE_ASSET__fw3VBJ8o__"